import Slider from 'react-slick';
import { Box } from '@mui/material';
import { useState } from 'react';
import CardCarrusel from './cardCarrusel';
import { Global } from '@emotion/react';

import otra from 'assets/images/carrusel/marca-fac.png';
import movint from 'assets/images/carrusel/image.png';
import Telep from 'assets/images/carrusel/teleperformance.png';
import urReformada from 'assets/images/carrusel/urReformada.png';
import Perimetral from 'assets/images/carrusel/Perimetral.png';
import lucania from 'assets/images/carrusel/Lucania.png';
import aplaudo from 'assets/images/carrusel/Applaudo.png';
import globaltec from 'assets/images/carrusel/Globaltec.png';
import tecnal from 'assets/images/carrusel/tecnal.png';
import intertelco from 'assets/images/carrusel/Intertelco.png';
import opamss from 'assets/images/carrusel/Opamss.png';
import codaltec from 'assets/images/carrusel/codaltec.png';
import mg from 'assets/images/carrusel/macarena.png';
import integral from 'assets/images/carrusel/integral.png';
import MKTypography from 'components/MKTypography';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const images = [
  otra,
  lucania,
  Perimetral,
  intertelco,
  integral,
  codaltec,
  aplaudo,
  movint,
  urReformada,
  opamss,
  globaltec,
  Telep,
  tecnal,
  mg,
];

const imageScales = {
  7: 0.7,
  5: 0.8,
  12: 1.2,
  1: 1.2,
};

const Carrusel = () => {
  const [slider, setSlider] = useState(null);

  return (
    <>
      <Global
        styles={{
          '.slick-dots': {
            display: 'block !important',
            position: 'relative !important',
            bottom: '0px !important',
            marginTop: '16px',
          },
          '.slick-dots li button:before': {
            fontSize: '5px',
            //   color: "#1A73E8",
            opacity: 0.75,
          },
          '.slick-dots li.slick-active button:before': {
            color: '#0d47a1',
            opacity: 1,
          },
          '.slick-dots li': {
            margin: '0 2px',
          },
        }}
      />

      <Box
        sx={{
          width: '100%',
          mt: { xs: 6, md: 7 },
          mb: { xs: 6, md: 10 },
          mx: 'auto',
          overflow: 'hidden',
        }}
      >
        {/* Título y descripción */}
        <Box textAlign="center" mb={4}>
          <MKTypography variant="h3" sx={{ color: '#1A73E8' }}>
            HEMOS CRECIDO JUNTOS
          </MKTypography>
          <MKTypography variant="body2" color="text" mt={1}>
            Estas son algunas de las organizaciones que hemos acompañado de manera exitosa en sus
            procesos de transformación digital:
          </MKTypography>
        </Box>

        {/* Carrusel */}
        <Slider
          ref={setSlider}
          dots={true}
          infinite={true}
          speed={500}
          slidesToShow={5}
          slidesToScroll={5}
          autoplay={true}
          autoplaySpeed={3000}
          arrows={false}
          responsive={[
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
              },
            },
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              },
            },
          ]}
        >
          {images.map((img, index) => (
            <CardCarrusel key={index} img={img} scale={imageScales[index] || 1} />
          ))}
        </Slider>
      </Box>
    </>
  );
};

export default Carrusel;
